/* global BX */
import { defineStore } from 'pinia';
import { extractBasket, toKey } from '@/app/store/composition.js';

export const useCartStore = defineStore('cartStore', {
	state: () => ({
		cart: {},
		cartByProductId: {},
		count: 0,
		currentProduct: {},
	}),
	getters: {
		getProduct: (state) => (id) => state.cartByProductId[toKey(id)],
		getMaxOfProduct: (state) => (id) => state.cartByProductId[toKey(id)]?.availableQuantity,
		getQuantity: (state) => (id) => state.cartByProductId[toKey(id)]?.quantity,
	},
	actions: {
		init() {
			this.getCart();
		},
		setCart({ basketItems, productsCount }) {
			this.count = productsCount;
			const cart = {};
			const map = {};
			Object.values(basketItems).forEach((item) => {
				const key = String(item.productId);
				cart[item.basketId] = item;
				map[key] = item;
			});
			this.cart = cart;
			this.cartByProductId = map;
		},
		addToCart({ productId, quantity }) {
			const key = toKey(productId);
			return BX.ajax.runAction('o2k:sitecore.api.Basket.addProduct', {
				data: {
					productId: key,
					quantity
				}
			}).then((response) => {
				this.setCart(extractBasket(response));
				this.currentProduct = this.cart[key];
				window.dispatchEvent(new CustomEvent('cart:add'));
			});
		},
		removeFromCart({ productId }) {
			const key = toKey(productId);
			return BX.ajax.runAction('o2k:sitecore.api.Basket.removeProduct', {
				data: {
					productId: key
				}
			}).then((response) => {
				this.setCart(extractBasket(response));
				window.dispatchEvent(new CustomEvent('cart:remove'));
			});
		},
		restoreInCart({ productId, quantity }) {
			const key = toKey(productId);
			return BX.ajax.runAction('o2k:sitecore.api.Basket.addProduct', {
				data: {
					productId: key,
					quantity,
					returnBasketData: true,
				}
			}).then((response) => {
				this.setCart(extractBasket(response));
				window.dispatchEvent(new CustomEvent('cart:restore'));
			});
		},
		setProductQuantity({ productId, quantity }) {
			const key = toKey(productId);
			return BX.ajax.runAction('o2k:sitecore.api.Basket.setProductQuantity', {
				data: {
					productId: key,
					quantity
				}
			}).then((response) => {
				this.setCart(extractBasket(response));
				window.dispatchEvent(new CustomEvent('cart:change'));
			});
		},
		getCart() {
			BX.ajax.runAction('o2k:sitecore.api.Basket.getBasket', {
				data: {}
			}).then((response) => this.setCart(extractBasket(response)));
		},
	},
});
